/* eslint-disable import/prefer-default-export */
export const reducerName = `commentForm`;
export const createCombineName = name => `comments/form/${name}`;
export const createReducerDotPathName = combineName =>
  `${combineName}.${reducerName}`;
export const createActionName = (combineName, name) =>
  `app/${createReducerDotPathName(combineName)}/${name}`;



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/comments/reducers/form/naming.js